import { jsx as _jsx } from "react/jsx-runtime";
import ClassNamesContext, { defaultClassNames } from './ClassNamesContext';

var ClassNamesProvider = function ClassNamesProvider(_ref) {
  var _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? defaultClassNames : _ref$classNames,
      children = _ref.children;
  return _jsx(ClassNamesContext.Provider, Object.assign({
    value: classNames
  }, {
    children: children
  }));
};

export default ClassNamesProvider;